import React from 'react';

const ENV_STYLES = {
  prod: 'env-badge--prod',
  sat: 'env-badge--staging',
  staging: 'env-badge--staging',
  ppd: 'env-badge--staging',
  dev: 'env-badge--dev',
  demo: 'env-badge--demo',
  perf: 'env-badge--demo',
};

function EnvironmentBadge() {
  const envName = window.ENV?.ENV_NAME;

  if (!envName) {
    return null;
  }

  const key = envName.toLowerCase();
  const modifier = ENV_STYLES[key] || 'env-badge--dev';

  return (
    <a className="navbar-brand" href="/" style={{ textDecoration: 'none' }}>
      <span className={`env-badge ${modifier}`}>{envName.toUpperCase()}</span>
    </a>
  );
}

export default EnvironmentBadge;
